var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWayniPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26426 10.0798L12.908 4.66211L17.9144 10.503L21.1539 6.72357L23.7361 9.73622C25.3954 11.6721 26.3075 14.1376 26.3075 16.6873V17.0308C26.3075 19.7645 25.2216 22.3862 23.2886 24.3193C21.3556 26.2523 18.7339 27.3382 16.0002 27.3382V27.3382C10.3076 27.3382 5.69287 22.7235 5.69287 17.0309V17.0309C5.69287 14.4812 6.60495 12.0156 8.26426 10.0798Z",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWayniPlus);
export default __webpack_public_path__ + "static/media/wayniPlus.dc5c03fb8c8e80e1af861c25a120e006.svg";
export { ForwardRef as ReactComponent };